<template>
    <div class="d-flex align-items-center mt-4 mb-3">
        <div class="mb-2">
            <div v-if="icon == 'dashboard'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    width="24"
                    fill="#00bea5"
                    viewBox="0 0 24 24"
                >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
                    />
                </svg>
            </div>
            <div v-else-if="icon == 'stakeholders'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    fill="#00bea5"
                >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path
                        d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z"
                    />
                </svg>
            </div>
            <div v-else-if="icon == 'shareholders'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    fill="#00bea5"
                >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path
                        d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05.02.01.03.03.04.04 1.14.83 1.93 1.94 1.93 3.41V18c0 .35-.07.69-.18 1H22c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5z"
                    />
                </svg>
            </div>
            <div v-else-if="icon == 'gateways'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enable-background="new 0 0 24 24"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#00bea5"
                >
                    <g><rect fill="none" height="24" width="24" /></g>
                    <g>
                        <g>
                            <rect height="7" width="3" x="4" y="10" />
                            <rect height="7" width="3" x="10.5" y="10" />
                            <rect height="3" width="20" x="2" y="19" />
                            <rect height="7" width="3" x="17" y="10" />
                            <polygon points="12,1 2,6 2,8 22,8 22,6" />
                        </g>
                    </g>
                </svg>
            </div>
            <div v-else-if="icon == 'transactions'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enable-background="new 0 0 24 24"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#00bea5"
                >
                    <g><rect fill="none" height="24" width="24" /></g>
                    <g>
                        <path
                            d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76V19h-1.75v-1.29 c-0.74-0.18-2.39-0.77-3.02-2.96l1.65-0.67c0.06,0.22,0.58,2.09,2.4,2.09c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03 c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5h1.75v1.24c1.84,0.32,2.51,1.79,2.66,2.23l-1.58,0.67 c-0.11-0.35-0.59-1.34-1.9-1.34c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45 C15.9,17.17,13.4,17.67,12.88,17.76z"
                        />
                    </g>
                </svg>
            </div>
            <div v-else-if="icon == 'card'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24px"
                    fill="#00bea5"
                    height="24px"
                    shape-rendering="geometricPrecision"
                    text-rendering="geometricPrecision"
                    image-rendering="optimizeQuality"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    viewBox="0 0 264 512.03"
                >
                    <path
                        fill-rule="nonzero"
                        d="M6.28 321.17C4.1 313.06 2.54 307 1.5 298.79.47 290.7 0 280.9 0 265.48v-93.19c0-8.54 3.28-16.3 8.55-21.93 5.28-5.65 12.56-9.16 20.56-9.16h204.97c8.02 0 15.33 3.52 20.62 9.18 5.29 5.65 8.57 13.45 8.57 22v93.43c1.2 14.57.82 26.29-.45 36.35-1.29 10.29-3.46 18.73-5.79 26.68-11.45 39.01-10.77 73.44-10.01 111.85.2 10.57.42 21.41.42 31.07l-.01.3c.37 12.74-2.38 22.78-8.63 29.75-6.33 7.06-15.9 10.6-29.05 10.19l-158.47.01c-12.47.35-21.1-3.29-26.75-10.01-5.62-6.68-7.89-16.05-7.83-27.28l-.02-73.07c0-16.77-.49-29.05-2.01-40.93-1.52-11.88-4.14-23.7-8.39-39.55zM116.77 73.86c0-6.76-3.25-12.75-8.28-16.49 5.03-3.75 8.28-9.74 8.28-16.49 0-11.35-9.2-20.56-20.55-20.56-11.35 0-20.55 9.21-20.55 20.56 0 6.75 3.26 12.74 8.29 16.49-5.03 3.74-8.29 9.73-8.29 16.49 0 11.35 9.2 20.55 20.55 20.55 11.35 0 20.55-9.2 20.55-20.55zm103.75 53.75V14.13c0-7.78-6.36-14.13-14.13-14.13H57.63C49.86 0 43.5 6.36 43.5 14.13v113.48h8.18V14.13c0-3.25 2.69-5.95 5.95-5.95h84.1v119.43h48.35V8.18h16.31c3.26 0 5.94 2.69 5.94 5.95v113.48h8.19zm-108.35 0v-21.18c0-5.24-10.41-5.23-10.41 0v21.18h10.41zm-21.48 0v-10.57c0-5.24-10.42-5.23-10.42 0v10.57h10.42zm22.1 304.55h38.43v42.42h-38.43v-42.42zm-60.94 0h38.42v42.42H51.85v-42.42zm121.89-66.86h38.43v109.09h-38.43V365.3zm-60.95 0h38.43v42.42h-38.43V365.3zm-60.94 0h38.42v42.42H51.85V365.3zm121.89-66.86h38.43v42.41h-38.43v-42.41zm-60.95 0h38.43v42.41h-38.43v-42.41zm-60.94 0h38.42v42.41H51.85v-42.41zm-6.36-116.09h173.04c1.92 0 3.5 1.69 3.5 3.75v76.27c0 2.06-1.58 3.75-3.5 3.75H45.49c-1.92 0-3.5-1.69-3.5-3.75V186.1c0-2.06 1.57-3.75 3.5-3.75zM12.77 297.18c.92 7.22 2.4 12.96 4.47 20.68 4.37 16.27 7.07 28.58 8.7 41.25 1.62 12.68 2.14 25.41 2.14 42.54l-.02 73.09c-.05 8.33 1.38 14.98 4.94 19.21 3.39 4.04 9.15 6.21 17.94 5.97l.65-.04h158.16l.18.03c9.79.33 16.56-1.91 20.63-6.44 4.02-4.48 5.77-11.59 5.51-21.02l-.04-.69c0-11.71-.19-21.4-.37-30.84-.78-39.47-1.48-74.85 10.5-115.68 2.2-7.48 4.23-15.34 5.39-24.64 1.17-9.29 1.52-20.15.41-33.72a6.5 6.5 0 0 1-.09-1.09v-93.41c0-5.25-2.01-10.02-5.23-13.47-3.22-3.44-7.67-5.57-12.56-5.57H29.11c-4.87 0-9.3 2.12-12.5 5.54-3.21 3.44-5.21 8.18-5.21 13.41v93.19c0 15.04.44 24.34 1.37 31.7z"
                    ></path>
                </svg>
            </div>
            <div v-else-if="icon == 'settlements'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enable-background="new 0 0 24 24"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#00bea5"
                >
                    <g><rect fill="none" height="24" width="24" /></g>
                    <g>
                        <path
                            d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M13.03,7.06L14.09,6l1.41,1.41 L16.91,6l1.06,1.06l-1.41,1.41l1.41,1.41l-1.06,1.06L15.5,9.54l-1.41,1.41l-1.06-1.06l1.41-1.41L13.03,7.06z M6.25,7.72h5v1.5h-5 V7.72z M11.5,16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2V16z M18,17.25h-5v-1.5h5V17.25z M18,14.75h-5v-1.5h5V14.75z"
                        />
                    </g>
                </svg>
            </div>
            <div v-else-if="icon == 'money_request'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#00bea5"
                >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"
                    />
                </svg>
            </div>
            <div v-else-if="icon == 'setting'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enable-background="new 0 0 24 24"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="#00bea5"
                >
                    <g>
                        <path d="M0,0h24v24H0V0z" fill="none" />
                        <path
                            d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
                        />
                    </g>
                </svg>
            </div>
            <div v-else-if="icon == 'wallets'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    fill="#00bea5"
                >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path
                        d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.98 1-1.72V9c0-.74-.41-1.37-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"
                    />
                    <circle cx="16" cy="12" r="1.5" />
                </svg>
            </div>
            <div v-else-if="icon == 'support'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enable-background="new 0 0 24 24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#00bea5"
                    width="24"
                >
                    <g><rect fill="none" height="24" width="24" /></g>
                    <g>
                        <g>
                            <path
                                d="M21,12.22C21,6.73,16.74,3,12,3c-4.69,0-9,3.65-9,9.28C2.4,12.62,2,13.26,2,14v2c0,1.1,0.9,2,2,2h1v-6.1 c0-3.87,3.13-7,7-7s7,3.13,7,7V19h-8v2h8c1.1,0,2-0.9,2-2v-1.22c0.59-0.31,1-0.92,1-1.64v-2.3C22,13.14,21.59,12.53,21,12.22z"
                            />
                            <circle cx="9" cy="13" r="1" />
                            <circle cx="15" cy="13" r="1" />
                            <path
                                d="M18,11.03C17.52,8.18,15.04,6,12.05,6c-3.03,0-6.29,2.51-6.03,6.45c2.47-1.01,4.33-3.21,4.86-5.89 C12.19,9.19,14.88,11,18,11.03z"
                            />
                        </g>
                    </g>
                </svg>
            </div>
            <div v-else-if="icon == 'paymentid'">
                <svg
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="24px"
                    height="24px"
                    viewBox="0 0 73.312 73.312"
                    fill="#00bea5"
                    style="enable-background: new 0 0 73.312 73.312"
                    xml:space="preserve"
                >
                    <g>
                        <g>
                            <g>
                                <path
                                    d="M66.368,20.672c0.224,0,0.224,0,0.447,0l-3.359-12.99c-0.896-3.809-4.929-6.049-8.513-4.929L5.217,15.969c-3.808,0.896-6.048,4.928-4.928,8.512l4.256,16.128v-9.632c0-5.822,4.704-10.526,10.528-10.526h51.295V20.672z"
                                />
                                <path
                                    d="M66.368,24.256h-51.52c-3.808,0-6.943,3.137-6.943,6.944v32.702c0,3.81,3.136,6.944,6.943,6.944h51.52c3.808,0,6.943-3.137,6.943-6.944V31.202C73.313,27.392,70.176,24.256,66.368,24.256z M68.609,63.905c0,1.345-1.119,2.239-2.239,2.239H14.85c-1.344,0-2.239-1.119-2.239-2.24v-8.286h56.223v8.286L68.609,63.905L68.609,63.905zM68.609,39.489h-56v-8.287c0-1.345,1.12-2.24,2.239-2.24h51.52c1.345,0,2.239,1.12,2.239,2.24L68.609,39.489L68.609,39.489z"
                                />
                            </g>
                        </g>
                    </g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                    <g></g>
                </svg>
            </div>
            <div v-else>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    width="24"
                    fill="#00bea5"
                    viewBox="0 0 24 24"
                >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
                    />
                </svg>
            </div>
        </div>
        <div>
            <h4 class="pr-2 mr-2 page_title" v-text="title_text"></h4>
        </div>
        <div class="mr-auto">
            <slot> </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'pageTitle',
    props: {
        title_text: {
            default: '',
            type: String
        },
        icon: {
            default: 'dashboard',
            type: String
        }
    }
};
</script>

<style scoped></style>